<p>
  Ако сте сменили електронната си поща или желаете да използвате нов имейл за вход и известия, може лесно да го
  актуализирате от настройките на профила си. Новият адрес ще се използва за вход, получаване на системни съобщения,
  нотификации и възстановяване на парола.
</p>
<h6 class="mt-3">Как да смените електронната си поща:</h6>
<ol>
  <li>
    Отворете менюто <strong>„Профил“</strong> в горната част на сайта и изберете <strong>„Настройки“</strong>.
  </li>
  <li>
    В секцията <strong>„Настройки на профила“</strong> натиснете бутона <strong>„Промени“</strong> до реда
    <strong>„Промяна на електронна поща“</strong>.
  </li>
  <li>
    В появилия се прозорец попълнете:
    <ul>
      <li><strong>Текуща парола</strong> – за потвърждение, че вие сте собственик на акаунта.</li>
      <li><strong>Нова електронна поща</strong> – валиден имейл адрес, до който имате достъп.</li>
    </ul>
  </li>
  <li>
    Натиснете бутона <strong>„Запази“</strong>, за да потвърдите промяната. Новият имейл ще бъде активен веднага.
  </li>
</ol>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Уверете се, че въведеният имейл е изписан правилно и е активен, тъй като ще се използва
  за вход и всички системни известия от платформата.
</div>
